export default "  <div class=\"d-flex h-100\" >\n      <img class=\"flex-grow-1\" src=\"../../assets/image/landing-page.png\">\n  </div>\n"